import { useAppSelector } from 'app/hooks';
import {
  FilterTabEnum,
  JobItem,
  JobParticipantEnum,
  JobTypeEnum,
  JobWorkflowStatusEnum,
} from 'domains/workspaceDomain';
import { useTranslation } from 'react-i18next';
import useJobCardInfo from '../features/Workspace/hooks/useJobCardInfo';

const {
  SUMMARY,
  RFQ,
  RFM,
  FILES,
  SHIPPING_BILLING,
  MORE_ACTIONS,
  NOTES,
  PROOFS,
  ACTIVITY,
} = FilterTabEnum;
const { PRODUCER, PROXY, CUSTOMER, OPERATOR } = JobParticipantEnum;

export const usePermissionFilterTabs = (jobData: JobItem) => {
  const { jobType = JobTypeEnum.INTERNAL, workflowStatus } = jobData;
  const { t } = useTranslation();
  const { hasProducer, hasOperator, hasProxy } = useJobCardInfo(jobData);
  const user = useAppSelector((state) => state.app.user);
  const uiStatusFilter = useAppSelector(
    (state) => state.workspace.uiStatusFilter
  );
  const getAllTabs = () => {
    return {
      [CUSTOMER]: [SUMMARY, FILES, PROOFS, NOTES, ACTIVITY, SHIPPING_BILLING],
      [PRODUCER]: [
        SUMMARY,
        FILES,
        PROOFS,
        NOTES,
        ACTIVITY,
        SHIPPING_BILLING,
        MORE_ACTIONS,
      ],
      [OPERATOR]: [
        SUMMARY,
        FILES,
        RFM,
        PROOFS,
        NOTES,
        ACTIVITY,
        SHIPPING_BILLING,
        MORE_ACTIONS,
      ],
      [PROXY]: [
        SUMMARY,
        FILES,
        PROOFS,
        NOTES,
        ACTIVITY,
        SHIPPING_BILLING,
        MORE_ACTIONS,
      ],
      [JobWorkflowStatusEnum.RFQ]: [RFQ, FILES],
    };
  };
  const tabDisplay = {
    [RFQ]: t('workspace.tabs.rfq'),
    [SUMMARY]: t('workspace.tabs.summary'),
    [RFM]: t('workspace.tabs.rfm'),
    [PROOFS]: t('workspace.tabs.proof'),
    [FILES]: t('workspace.tabs.file'),
    [NOTES]: t('workspace.tabs.notes'),
    [ACTIVITY]: t('workspace.tabs.activity'),
    [SHIPPING_BILLING]: t('workspace.tabs.shipbill'),
    [MORE_ACTIONS]: t('workspace.tabs.more'),
  };
  if (jobData.workflowStatus === JobWorkflowStatusEnum.RFQ) {
    return {
      tabs: getAllTabs()[JobWorkflowStatusEnum.RFQ],
      tabDisplays: tabDisplay,
    };
  }
  if (!user || !uiStatusFilter || !workflowStatus || !jobType) {
    return {
      tabs: [],
      tabDisplays: {},
    };
  }
  let participant = CUSTOMER;
  if (hasOperator) {
    participant = OPERATOR;
  } else if (hasProducer) {
    participant = PRODUCER;
  } else if (hasProxy) {
    participant = PROXY;
  }

  const isIllegalJobRole = !participant;
  const isIllegalJobType = !jobType;
  const isIllegalUiStatusFilter = !uiStatusFilter;

  let participantTabs: FilterTabEnum[] = getAllTabs()[participant];

  if (!jobData.artworkConfirm) {
    participantTabs = participantTabs?.filter((item) => item !== PROOFS);
  }
  if (!jobData.hasRfm) {
    participantTabs = participantTabs?.filter((item) => item !== RFM);
  }
  // console.log('dataId : ' + jobData.id + ' ,participantTabs:', participantTabs);
  // console.log(
  //   'isIllegalJobRole: ',
  //   isIllegalJobRole,
  //   ', isIllegalJobType: ',
  //   isIllegalJobType + ',isIllegalUiStatusFilter:',
  //   isIllegalUiStatusFilter
  // );
  if (isIllegalJobRole || isIllegalJobType || isIllegalUiStatusFilter) {
    return {
      tabs: [],
      tabDisplays: {},
    };
  } else {
    return {
      tabs: jobData.isQuote ? [FILES] : participantTabs,
      tabDisplays: tabDisplay,
    };
  }
};
